// ref: https://github.com/asosteam/asos-core-api-specifications/blob/fd057c92a2a5570a6df6a2a5c7753e6f41c25fd5/commerce-bag/api/commerce-bag-v4.yaml#L4670-L4681
export type ExpandOptions = (
  | "summary"
  | "total"
  | "getdeliveryoptions"
  | "spendLevelDiscount"
  | "address"
  | "expiredItems"
)[];

export const buildExpandQueryValue = (expand?: ExpandOptions) => {
  if (!expand) {
    return null;
  }

  const uniqueExpandValues = Array.from(new Set(expand));

  if (uniqueExpandValues.length === 0) {
    return null;
  }

  return String(uniqueExpandValues);
};
